module.exports = __webpack_public_path__ + "media/icon_transaction/frog_4-6c3cf0f7.png";